import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { providerContractQKeys } from "@hooks/queries/providerContract/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { UpdateContractPayload } from "@customTypes/providerContract";


interface MutationProps {
  contractId: string;
  contractData: UpdateContractPayload;
}

export const useUpdateContract = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ contractId, contractData }: MutationProps) => {
      return api.put(`clinic/provider-contracts/${contractId}`, contractData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "update-contract-success",
      });
      // Invalidate all contract queries to refetch fresh data
      queryClient.invalidateQueries({
        queryKey: providerContractQKeys.all(),
      });
    },

    onError: (res: any) => {
      console.error("[From Update Contract]", res);
      handleErrors(res, "mutation");
    },
  });
};
